export default "__VITE_ASSET__Jhrk72BN__"